module.exports = __webpack_public_path__ + "static/img/voucher-label.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/voucher-label.png
// module id = 592
// module chunks = 0